import {
  Component,
  Inject,
  OnInit,
  ViewChild,
  Output,
  EventEmitter,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { ApiEndpointsService } from 'src/app/core/services/api-endpoints.service';

import { DataService } from 'src/app/core/services/data.service';

import { IHttpService } from 'src/app/core/services/ihttp.service';
import { FilterSelection } from 'src/app/core/classes/filterSelection';
import { Observable, BehaviorSubject } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { FilterTypeEnum } from './filter-type-enum';
import { OnSelectEvent } from 'src/app/shared/components/combo/combo.component';

@Component({
  selector: 'dq-filters2',
  templateUrl: './filters2.component.html',
  styleUrls: ['./filters.component.scss'],
})
export class FiltersComponent2 implements OnInit {
  @Output()
  filterChange = new EventEmitter<Object>();

  constructor(
    private apiEndpointsService: ApiEndpointsService,
    private dataService: DataService,
    @Inject('HttpService') private httpService: IHttpService,
    translate: TranslateService
  ) { }

  brands: any[] = [];
  subbrands: any[] = [];
  lines: any[] = [];
  sellers: any[] = [];
  countries: any[] = [];
  regions: any[] = [];
  subregions: any[] = [];
  formats: any[] = [];
  denominations: any[] = [];

  filter_selection: FilterSelection = new FilterSelection();
  last_filter_selection: FilterSelection = new FilterSelection();

  public isCollapsed = false;
  public FilterTypeEnum = FilterTypeEnum;

  ngOnInit(): void {
    this.dataService.getUserInfo$().subscribe((userInfo) => {
      if (userInfo != null) {
        this.loadSellers();
        this.loadBrands();
        this.loadCountries();
      }
    });
  }

  loadBrands() {
    this.httpService
      .get(this.apiEndpointsService.getBrandsEndpoint(this.filter_selection))
      .subscribe((br) => {
        this.brands = [];
        for (let i = 0; i < br.value.length; i++) {
          this.brands.push({
            id: br.value[i].BRANDID,
            name: br.value[i].BRANDNAME,
          });
        }
      });
  }

  loadCountries() {
    this.httpService
      .get(this.apiEndpointsService.getCountries(this.filter_selection))
      .subscribe((cr) => {
        this.countries = [];
        for (let i = 0; i < cr.value.length; i++) {
          if (
            cr.value[i].SHIPPINGCOUNTRY != null &&
            cr.value[i].SHIPPINGCOUNTRY != ''
          ) {
            this.countries.push({
              id: cr.value[i].SHIPPINGCOUNTRY,
              name: cr.value[i].SHIPPINGCOUNTRY,
            });
          }
        }
      });
  }

  loadSellers() {
    this.httpService
      .get(this.apiEndpointsService.getSellers(this.filter_selection))
      .subscribe((sl) => {
        this.sellers = [];
        for (let i = 0; i < sl.value.length; i++) {
          if (sl.value[i].IDRDC != null && sl.value[i].RDC != '') {
            this.sellers.push({
              id: sl.value[i].IDRDC,
              name: sl.value[i].NAMERDC,
            });
          }
        }
      });
  }

  showhideFilters() {
    this.dataService.sendShowHideFilters();
  }

  loadSubBrands() {
    this.httpService
      .get(
        this.apiEndpointsService.getSubBrandsByBrandEndpoint(
          this.filter_selection
        )
      )
      .toPromise()
      .then((result) => {
        this.subbrands = [];
        this.lines = [];
        this.formats = [];
        for (let i = 0; i < result.value.length; i++) {
          this.subbrands.push({
            id: result.value[i].SUBBRANDID,
            name: result.value[i].SUBBRANDNAME,
          });
        }
      });
  }

  changeBrand(onSelectEvent: OnSelectEvent) {
    const item = onSelectEvent?.selectedItem;
    if (item) {
      this.filter_selection.brand = item.id;
      this.loadSubBrands();
      this.emitFilterChange(onSelectEvent.existsPreviousFilter);
      this.updateLocationFilterOptions(this.filter_selection);
      this.updateSellersFilterOptions(this.filter_selection);
    } else {
      this.subbrands = [];
      this.filter_selection.brand = '';
    }
  }

  loadLines() {
    this.httpService
      .get(
        this.apiEndpointsService.getLinesBySubBrandEndpoint(
          this.filter_selection
        )
      )
      .toPromise()
      .then((result) => {
        this.lines = [];
        for (let i = 0; i < result.value.length; i++) {
          this.lines.push({
            id: result.value[i].LINEID,
            name: result.value[i].LINENAME,
          });
        }
      });
  }
  changeSubBrand(onSelectEvent: OnSelectEvent) {
    const subbrand = onSelectEvent?.selectedItem;
    if (subbrand) {
      this.filter_selection.subbrand = subbrand.id;
      this.loadLines();
      this.emitFilterChange(onSelectEvent.existsPreviousFilter);
      this.updateLocationFilterOptions(this.filter_selection);
      this.updateSellersFilterOptions(this.filter_selection);
    } else {
      this.lines = [];
      this.filter_selection.subbrand = '';
    }
  }

  loadFormats() {
    this.httpService
      .get(
        this.apiEndpointsService.getFormatsByLineEndpoint(this.filter_selection)
      )
      .subscribe((result) => {
        this.formats = [];
        for (let i = 0; i < result.value.length; i++) {
          this.formats.push({
            id: result.value[i].FORMATID,
            name: result.value[i].FORMATNAME,
          });
        }
      });
  }

  changeLine(onSelectEvent: OnSelectEvent) {
    const line = onSelectEvent?.selectedItem;
    if (line) {
      this.filter_selection.line = line.id;
      this.loadFormats();
      this.emitFilterChange(onSelectEvent.existsPreviousFilter);
      this.updateLocationFilterOptions(this.filter_selection);
      this.updateSellersFilterOptions(this.filter_selection);
    } else {
      this.formats = [];
      this.filter_selection.line = '';
    }
  }

  changeFormat(onSelectEvent: OnSelectEvent) {
    const format = onSelectEvent?.selectedItem;
    if (format) {
      this.filter_selection.format = format.id;
      this.emitFilterChange(onSelectEvent.existsPreviousFilter);
      this.updateLocationFilterOptions(this.filter_selection);
      this.updateSellersFilterOptions(this.filter_selection);
    } else {
      this.filter_selection.format = '';
    }
  }

  loadRegions() {
    this.httpService
      .get(this.apiEndpointsService.getRegions(this.filter_selection))
      .subscribe((result) => {
        this.regions = [];
        for (let i = 0; i < result.value.length; i++) {
          this.regions.push({
            id: result.value[i].SHIPPINGSTATE,
            name: result.value[i].SHIPPINGSTATE,
          });
        }
      });
  }

  changeCountry(onSelectEvent: OnSelectEvent) {
    const item = onSelectEvent?.selectedItem;
    if (item) {
      this.filter_selection.country = item.id;
      this.loadRegions();
      this.emitFilterChange(onSelectEvent.existsPreviousFilter);
      this.updateProductOptionsFilter(this.filter_selection);
      this.updateSellersFilterOptions(this.filter_selection);
    } else {
      this.regions = [];
      this.filter_selection.country = '';
    }
  }

  loadSubRegions() {
    this.httpService
      .get(this.apiEndpointsService.getCities(this.filter_selection))
      .subscribe((result) => {
        this.subregions = [];
        for (let i = 0; i < result.value.length; i++) {
          this.subregions.push({
            id: result.value[i].SHIPPINGCITY,
            name: result.value[i].SHIPPINGCITY,
          });
        }
      });
  }

  changeRegion(onSelectEvent: OnSelectEvent) {
    const item = onSelectEvent?.selectedItem;
    if (item) {
      this.filter_selection.region = item.id;
      this.loadSubRegions();
      this.updateProductOptionsFilter(this.filter_selection);
      this.updateSellersFilterOptions(this.filter_selection);
      this.emitFilterChange(onSelectEvent.existsPreviousFilter);
    } else {
      this.subregions = [];
      this.filter_selection.region = '';
    }
  }

  changeSubregion(onSelectEvent: OnSelectEvent) {
    const subregion = onSelectEvent?.selectedItem;
    if (subregion) {
      this.filter_selection.subregion = subregion.id;
      this.emitFilterChange(onSelectEvent.existsPreviousFilter);
      this.updateProductOptionsFilter(this.filter_selection);
      this.updateSellersFilterOptions(this.filter_selection);
    } else {
      this.filter_selection.subregion = '';
    }
  }

  unselectedCountries(event: any) {
    this.filter_selection.country = '';
    this.emitFilterChange();
  }
  unselectedRegion(event: any) {
    this.filter_selection.region = '';
    this.emitFilterChange();
  }
  unselectedSubregion(event: any) {
    this.filter_selection.subregion = '';
    this.emitFilterChange();
  }

  unselectedBrand(event: any) {
    this.filter_selection.brand = '';
    this.emitFilterChange();
  }
  unselectedSubbrand(event: any) {
    this.filter_selection.subbrand = '';
    this.emitFilterChange();
  }
  unselectedLine(event: any) {
    this.filter_selection.line = '';
    this.emitFilterChange();
  }
  unselectedFormat(event: any) {
    this.filter_selection.format = '';
    this.emitFilterChange();
  }

  changeSeller(onSelectEvent: OnSelectEvent) {
    const item = onSelectEvent?.selectedItem;
    if (item) {
      this.filter_selection.seller = item.id;
      this.emitFilterChange(onSelectEvent.existsPreviousFilter);
      this.updateLocationFilterOptions(this.filter_selection);
      this.updateProductOptionsFilter(this.filter_selection);
    } else {
      this.filter_selection.seller = '';
    }
  }
  unselectedSeller(event: any) {
    this.filter_selection.format = '';
    this.emitFilterChange();
  }

  emitFilterChange(isLoading = false) {
    if (
      JSON.stringify(this.filter_selection) !==
      JSON.stringify(this.last_filter_selection)
    ) {
      this.last_filter_selection = Object.assign({}, this.filter_selection);
      if (!isLoading) {
        this.filterChange.emit(this.filter_selection);
        this.dataService.setFilterState(this.filter_selection);
      }
    }
  }

  //update the values of not selected filter to make in consideration
  //the values of new selection
  updateProductOptionsFilter(filter_selection: FilterSelection) {
    if (filter_selection.brand == '') {
      this.loadBrands();
    } else if (filter_selection.subbrand == '') {
      this.loadSubBrands();
    } else if (filter_selection.line == '') {
      this.loadLines();
    } else if (filter_selection.format == '') {
      this.loadFormats();
    }
  }

  //update the values of not selected filter to make in consideration
  //the values of new selection
  updateLocationFilterOptions(filter_selection: FilterSelection) {
    if (filter_selection.country == '') {
      this.loadCountries();
    } else if (filter_selection.region == '') {
      this.loadRegions();
    } else if (filter_selection.subregion == '') {
      this.loadSubRegions();
    }
  }

  //update the values of not selected filter to make in consideration
  //the values of new selection
  updateSellersFilterOptions(filter_selection: FilterSelection) {
    if (filter_selection.seller == '') {
      this.loadSellers();
    }
  }
}
